/**
 * Reads the Shopify API key injected at build time into the
 * `<meta name="shopify-api-key">` tag (see vite.config.ts transformIndexHtml).
 *
 * A production build now fails loudly when the key is missing, but a bundle can
 * still be served with an empty key (e.g. a misconfigured Docker build arg). In
 * that case App Bridge cannot initialise and embedded auth silently breaks, so
 * we surface the problem instead (see BuildKeyError / RootGate).
 */
export function getShopifyApiKey(doc: Document = document): string {
  const meta = doc.querySelector('meta[name="shopify-api-key"]');
  return meta?.getAttribute('content')?.trim() || '';
}
